import { MallMainLoader } from '@/router'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useLoaderData } from 'react-router-dom'
import Footer from './Footer'
import MallBanner from './MallBanner'
import ProductList from './ProductList'

function MainPage() {
    const loaderData = useLoaderData() as MallMainLoader;
    const { mallInfo, notificationList, tagNames, shopName } = loaderData
    return (
        <>
            <Helmet>
                {
                    mallInfo ? (
                        <>
                            <title>{shopName}</title>
                            <meta name="og:title" content={`${shopName}`}></meta>
                            <meta name='description' content={`${mallInfo.description}`}></meta>
                            <meta name='og:description' content={`${mallInfo.description}`}></meta>
                        </>
                    ) : (
                        <>
                            <title>LazyMall SHOP</title>
                            <meta name="og:title" content="LazyMall SHOP"></meta>
                            <meta name='description' content="LazyMall SHOP"></meta>
                            <meta name='og:description' content="LazyMall SHOP"></meta>
                        </>
                    )
                }
            </Helmet>
            <MallBanner mallInfo={mallInfo} notificationList={notificationList} />
            <ProductList tagNames={tagNames} />
            <Footer footerInfo={loaderData} />
        </>
    )
}

export default MainPage